import { render, staticRenderFns } from "./ProjectDictModal.vue?vue&type=template&id=e97bb14a&scoped=true"
import script from "./ProjectDictModal.vue?vue&type=script&lang=js"
export * from "./ProjectDictModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97bb14a",
  null
  
)

export default component.exports